import { DefaultResponse } from "@shared/dtos/responses/commonResponses.dto"
import { AcceptUserInvitationWithNewAccountRequest } from "@shared/zod/schemas/requests/userInvitationRequests"
import { ResolveUserInvitationResponse } from "@shared/zod/schemas/responses/userInvitations"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"

/**
 * Public endpoints for the invitation acceptance page (`/invitation/:token`).
 * No session required: `resolve` renders the choice card and `acceptWithNewAccount`
 * creates a brand-new account. Connecting an existing account is authenticated
 * and lives in `UserInvitationService.acceptWithExistingAccount`.
 */
export const resolve = async (token: string): Promise<ResolveUserInvitationResponse> => {
  const resp = await axiosPublic({ url: `/public/userinvitations/${token}`, method: "get" })
  return resp.data
}

export const acceptWithNewAccount = async (
  token: string,
  req: AcceptUserInvitationWithNewAccountRequest
): Promise<DefaultResponse> => {
  const resp = await axiosPublic({ url: `/public/userinvitations/${token}/accept-new`, method: "post", data: req })
  return resp.data
}
